import { useMemo, useState, React, useEffect } from "react";
import DataGrid from "react-data-grid";
import "react-data-grid/lib/styles.css";
import Switch from "@mui/material/Switch";
import {
  ADMIN,
  COLLEGE,
  FACULTY,
  HELPDESK,
  INDUSTRY,
  PROFESSOR,
  SCHOOL,
  SPONSER,
  SPONSER_INDUSTRY,
  TEACHER,
  VISITOR,
  VOLUNTEER,
} from "../utils/constants";
import { updateSponserIndustry, updateUser } from "../utils/firebase-config";

function getColumns(type, currentUser) {
  const schoolList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",
      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      width: "auto",
      frozen: true,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },
    {
      key: "school_unique_code",
      name: "Unique School Code",
      width: "max-content",
      frozen: false,
    },
    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "school_name",
      name: "School Name",
      width: "auto",
      frozen: false,
    },
    {
      key: "teachers",
      name: "Teachers",
      frozen: false,
      renderSummaryCell({ row }) {
        let count = 0;
        for (let item of row.data) {
          count += parseFloat(item.teachers);
        }
        return `${count} teachers`;
      },
    },
    {
      key: "contact_number_head",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
  ];
  const collegeList = [
  {
    key: "id",
    name: "S. No.",
    width: "max-content",
    frozen: true,
    renderSummaryCell() {
      return <strong>Total</strong>;
    }
  },
  {
    key: "name",
    name: "Name",
    width: "auto",
    frozen: true,
    renderSummaryCell({ row }) {
      return `${row.totalCount} records`;
    }
  },
  {
    key: "college_unique_code",
    name: "Unique College Code",
    width: "max-content",
    frozen: false
  },
  {
    key: "email",
    name: "Email",
    width: "auto",
    frozen: false
  },
  {
    key: "college_name",
    name: "College Name",
    width: "auto",
    frozen: false
  },
  {
    // If your aggregate field is named differently (e.g., "faculty_count"),
    // replace "professors" below with that key.
    key: "professors",
    name: "Professors",
    frozen: false,
    renderSummaryCell({ row }) {
      let count = 0;
      for (const item of row.data) {
        count += parseFloat(item.professors);
      }
      return `${count} professors`;
    }
  },
  {
    key: "contact_number_head",
    name: "Contact Number",
    width: "auto",
    frozen: false
  },
  {
    key: "created_at",
    name: "Registration Date",
    width: "auto",
    frozen: false,
    renderCell(props) {
      const value =
        props.row.created_at ||
        "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
      const d = new Date(value);
      return `${d.toLocaleDateString()} - ${d.toLocaleTimeString()}`;
    }
  }
];

  const helpDeskList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",

      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      width: "auto",
      frozen: true,
    },
    {
      key: "emp_code",
      name: "Entry No./ Employee Code",
      width: "auto",
      frozen: false,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },

    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "gender",
      name: "Gender",
      width: "auto",
      frozen: false,
    },
    {
      key: "contact_number",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
    {
      key: "t_shirt_size",
      name: "T-Shirt Size",
      width: "auto",
      frozen: false,
    },
    {
      key: "t_shirt_received",
      name: "T-Shirt Received",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value = props.row.t_shirt_received;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.t_shirt_received = data.target.checked;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "food_token",
      name: "Food Token Received",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value = props.row.food_token;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.food_token = data.target.checked;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verified",
      name: "Verified",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value = props.row.verified;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.verified = data.target.checked;
                props.row.verify_by = currentUser.email;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verify_by",
      name: "Verified",
      width: "auto",
      frozen: false,
    },
  ];
  const adminList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",

      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      width: "auto",
      frozen: true,
    },
    {
      key: "emp_code",
      name: "Entry No./ Employee Code",
      width: "auto",
      frozen: false,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },

    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "gender",
      name: "Gender",
      width: "auto",
      frozen: false,
    },
    {
      key: "contact_number",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
    // {
    //   key: "t_shirt_size",
    //   name: "T-Shirt Size",
    //   width: "auto",
    //   frozen: false,
    // },
    // {
    //   key: "t_shirt_received",
    //   name: "T-Shirt Received",
    //   width: "auto",
    //   frozen: false,
    //   renderCell(props) {
    //     const value = props.row.t_shirt_received;
    //     return (
    //       <>
    //         <Switch
    //           checked={value}
    //           onChange={(data) => {
    //             props.row.t_shirt_received = data.target.checked;
    //             updateUser(props.row);
    //           }}
    //         />
    //       </>
    //     );
    //   },
    // },
    {
      key: "food_token",
      name: "Food Token Received",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value = props.row.food_token;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.food_token = data.target.checked;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verified",
      name: "Verified",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value = props.row.verified;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.verified = data.target.checked;
                props.row.verify_by = currentUser.email;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verify_by",
      name: "Verified",
      width: "auto",
      frozen: false,
    },
  ];
  const volunteerList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",
      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      width: "auto",
      frozen: true,
    },
    {
      key: "emp_code",
      name: "Entry No./ Employee Code",
      width: "max-content",
      frozen: false,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },

    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "contact_number",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "gender",
      name: "Gender",
      width: "min-content",
      frozen: false,
    },
    {
      key: "department",
      name: "Department",
      width: "auto",
      frozen: false,
    },
    {
      key: "volunteer_type",
      name: "Volunteer Type",
      width: "max-content",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
    {
      key: "t_shirt_size",
      name: "T-Shirt Size",
      width: "max-content",
      frozen: false,
    },
    {
      key: "t_shirt_received",
      name: "T-Shirt Received",
      width: "max-content",
      frozen: false,
      renderCell(props) {
        const value = props.row.t_shirt_received;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.t_shirt_received = data.target.checked;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "food_token",
      name: "Food Token Received",
      width: "max-content",
      frozen: false,
      renderCell(props) {
        const value = props.row.food_token;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.food_token = data.target.checked;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verified",
      name: "Verified",
      width: "max-content",
      frozen: false,
      renderCell(props) {
        const value = props.row.verified;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.verified = data.target.checked;
                props.row.verify_by = currentUser.email;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verify_by",
      name: "Verified",
      width: "auto",
      frozen: false,
    },
  ];

  const industryList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",
      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      frozen: true,
      width: "auto",
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },
    {
      key: "industry_name",
      name: "Industry Name",
      width: "auto",
      frozen: false,
    },
    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "address",
      name: "Industry Address",
      width: "auto",
      frozen: false,
    },
    {
      key: "gender",
      name: "Gender",
      width: "max-content",
      frozen: false,
    },
    {
      key: "contact_number",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
  ];

  const teachersList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",
      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      width: "auto",
      frozen: true,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },
    {
      key: "school_unique_code",
      name: "Unique School Code",
      width: "max-content",
      frozen: false,
    },

    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "school",
      name: "School Name",
      width: "auto",
      frozen: false,
    },
    {
      key: "number_of_students",
      name: "Number of Students",
      width: "max-content",
      frozen: false,
      renderSummaryCell({ row }) {
        let count = 0;
        for (let item of row.data) {
          count += parseFloat(item.number_of_students);
        }
        return `${count} students`;
      },
    },
    {
      key: "contact_number",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
  ];
  const professorsList = [
  {
    key: "id",
    name: "S. No.",
    width: "max-content",
    frozen: true,
    renderSummaryCell() {
      return <strong>Total</strong>;
    }
  },
  {
    key: "name",
    name: "Name",
    width: "auto",
    frozen: true,
    renderSummaryCell({ row }) {
      return `${row.totalCount} records`;
    }
  },
  {
    key: "college_unique_code",
    name: "Unique College Code",
    width: "max-content",
    frozen: false
  },
  {
    key: "email",
    name: "Email",
    width: "auto",
    frozen: false
  },
  {
    // If your docs store the field as `college_name`, either:
    // 1) keep key "college" and map it when building rows, or
    // 2) change this key to "college_name".
    key: "college",
    name: "College Name",
    width: "auto",
    frozen: false
  },
  {
    key: "number_of_students",
    name: "Number of Students",
    width: "max-content",
    frozen: false,
    renderSummaryCell({ row }) {
      let count = 0;
      for (const item of row.data) {
        count += parseFloat(item.number_of_students);
      }
      return `${count} students`;
    }
  },
  {
    key: "contact_number",
    name: "Contact Number",
    width: "auto",
    frozen: false
  },
  {
    key: "created_at",
    name: "Registration Date",
    width: "auto",
    frozen: false,
    renderCell(props) {
      const value =
        props.row.created_at ||
        "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
      const d = new Date(value);
      return `${d.toLocaleDateString()} - ${d.toLocaleTimeString()}`;
    }
  }
];

  const visitorList = [
    {
      key: "id",
      name: "S. No.",
      width: "max-content",
      frozen: true,

      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      width: "auto",
      frozen: true,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },
    {
      key: "email",
      name: "Email",
      width: "auto",
      frozen: false,
    },
    {
      key: "gender",
      name: "Gender",
      width: "max-content",
      frozen: false,
    },
    {
      key: "contact_number",
      name: "Contact Number",
      width: "auto",
      frozen: false,
    },
    {
      key: "address",
      name: "Address",
      width: "auto",
      frozen: false,
    },
    {
      key: "created_at",
      name: "Registration Date",
      width: "auto",
      frozen: false,
      renderCell(props) {
        const value =
          props.row.created_at ||
          "Fri Oct 30 2023 14:31:50 GMT+0530 (India Standard Time)";
        return `${new Date(value).toLocaleDateString()} - ${new Date(
          value
        ).toLocaleTimeString()}`;
      },
    },
  ];
  const sponserUserList = [
    {
      key: "id",
      name: "S. No.",
      frozen: true,
      resizable: false,
      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "name",
      name: "Name",
      frozen: true,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },
    {
      key: "sponsor_id",
      name: "Sponser Industry",
      frozen: true,
    },
    {
      key: "email",
      name: "Email",
      frozen: true,
    },
    {
      key: "address",
      name: "Industry Address",
      frozen: true,
    },
    {
      key: "gender",
      name: "Gender",
      frozen: true,
    },
    {
      key: "contact_number",
      name: "Contact Number",
      frozen: true,
    },
    {
      key: "verified",
      name: "Verified",
      width: "max-content",
      frozen: false,
      renderCell(props) {
        const value = props.row.verified;
        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.verified = data.target.checked;
                props.row.verify_by = currentUser.email;
                updateUser(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verify_by",
      name: "Verified",
      width: "auto",
      frozen: false,
    },
  ];
  const sponserIndustryList = [
    {
      key: "id",
      name: "S. No.",
      frozen: true,
      resizable: false,
      renderSummaryCell() {
        return <strong>Total</strong>;
      },
    },
    {
      key: "sponsor_name",
      name: "Name",
      frozen: true,
      renderSummaryCell({ row }) {
        return `${row.totalCount} records`;
      },
    },
    {
      key: "sponsorship_amount",
      name: "Amount",
      frozen: true,
      renderSummaryCell({ row }) {
        let count = 0;
        for (let item of row.data) {
          count += parseFloat(item.sponsorship_amount);
        }
        return `${count} Rs`;
      },
    },
    {
      key: "payment_receipt_url",
      name: "Payment Receipt",
      frozen: true,
      renderCell({ row }) {
        return (
          <a href={row.payment_receipt_url} target="_blank">
            View Receipt
          </a>
        );
      },
    },
    {
      key: "payment_mode",
      name: "Payment Mode",
      frozen: true,
    },
    {
      key: "payment_date",
      name: "Payment Date",
      frozen: true,
    },
    {
      key: "verified",
      name: "Verified",
      width: "max-content",
      frozen: false,
      renderCell(props) {
        const value = props.row.verified;

        return (
          <>
            <Switch
              checked={value}
              onChange={(data) => {
                props.row.verified = data.target.checked;
                props.row.verify_by = currentUser.email;
                updateSponserIndustry(props.row);
              }}
            />
          </>
        );
      },
    },
    {
      key: "verify_by",
      name: "Verified",
      width: "auto",
      frozen: false,
    },
  ];
  switch (type) {
    case SCHOOL:
      return schoolList;
    case "Admin":
      return adminList;
    case COLLEGE:
     return collegeList;
     case PROFESSOR:
      return professorsList;
    case HELPDESK:
      return helpDeskList;
    case TEACHER:
      return teachersList;
    case VISITOR:
      return visitorList;
    case INDUSTRY:
      return industryList;
    case SPONSER:
      return sponserUserList;
    case SPONSER_INDUSTRY:
      return sponserIndustryList;
    case VOLUNTEER:
    case FACULTY:
      return volunteerList;

    default:
      return [];
  }
}

// function rowKeyGetter(row) {
//   return row.id;
// }

function getComparator(sortColumn) {
  switch (sortColumn) {
    case "name":
    case "school_unique_code":
    case "college_unique_code":
    case "email":
    case "school_name":
    case "college_name":
    case "teachers":
    case "college_name":   
    case "contact_number_head":
    case "emp_code":
    case "t_shirt_received":
    case "food_token":
    case "verified":
    case "contact_number":
    case "gender":
    case "department":
    case "volunteer_type":
    case "t_shirt_size":
    case "industry_name":
    case "address":
    case "number_of_students":
      
      return (a, b) => {
        return `${a[sortColumn]}`.localeCompare(`${b[sortColumn]}`);
      };

    case "id":
      return (a, b) => {
        return a[sortColumn] - b[sortColumn];
      };
    default:
      throw new Error(`unsupported sortColumn: "${sortColumn}"`);
  }
}

export default function UsersTable(props) {
  const [rows, setRows] = useState([]);
  const [sortColumns, setSortColumns] = useState([]);
  // const [selectedRows, setSelectedRows] = useState(() => new Set());

  useMemo(() => {
    setRows(props.users);
  }, [props.users]);
  const summaryRows = useMemo(() => {
    console.log(props.users);
    return [
      {
        id: "total_0",
        totalCount: rows.length,
        data: rows,
        yesCount: rows.filter((r) => r.available).length,
      },
    ];
  }, [rows]);

  const sortedRows = useMemo(() => {
    if (sortColumns.length === 0) return rows;

    return [...rows].sort((a, b) => {
      for (const sort of sortColumns) {
        const comparator = getComparator(sort.columnKey);
        const compResult = comparator(a, b);
        if (compResult !== 0) {
          return sort.direction === "ASC" ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [rows, sortColumns]);

  const gridElement = (
    <DataGrid
      style={{
        flex: "1",
        marginTop: "10px",
      }}
      // rowKeyGetter={rowKeyGetter}
      columns={getColumns(props.type, props.currentUser)}
      rows={sortedRows}
      defaultColumnOptions={{
        sortable: true,
        resizable: false,
      }}
      // selectedRows={selectedRows}
      // onSelectedRowsChange={setSelectedRows}
      // onRowsChange={setRows}
      sortColumns={sortColumns}
      onSortColumnsChange={setSortColumns}
      // topSummaryRows={summaryRows}
      bottomSummaryRows={summaryRows}
      // className="fill-grid"
      // direction={"ltr"}
    />
  );

  return gridElement;
}
